import { useLazyGetSingleMediaQuery } from '@/features/media/api'
import { setMediaDetailsState } from '@/features/media-details/slice'
import { enqueueToast } from '@/features/toasts/slice'
import { useAppDispatch } from '@/redux/hooks'

export const useGetSingleMedia = () => {
  const dispatch = useAppDispatch()
  const [trigger, request] = useLazyGetSingleMediaQuery()

  const openDetails = async (id: string) => {
    try {
      const item = await trigger(id).unwrap()
      dispatch(
        setMediaDetailsState({ openDrawer: true, searchResultItem: item }),
      )
    } catch (error) {
      console.error('Failed to load media details', error)
      dispatch(
        enqueueToast({
          message: `Unable to load details for media ${id}.`,
          severity: 'error',
        }),
      )
    }
  }

  return { openDetails, isFetching: request.isFetching }
}
